<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-21 17:05:28
 * @Description: 通讯录详情页
-->
<template>
  <div class="address-book-list">
    <div class="component-container">
      <div class="container-head">
        <div class="container-head-title">
          <i class="icon-tongxunlu iconfont"></i>
          <span class="subpage-head-text">通讯录</span>
          <common-button
            style="float: right"
            size="default"
            type="cancel"
            image
            @click="handleGoBackClick()"
            >返回</common-button
          >
          <common-button
            v-if="admin"
            type="primary"
            size="default"
            class="export-address-book"
            style="float: right; margin-right: 10px"
            @click="exportAddressBook"
            >导出通讯录
          </common-button>
        </div>
      </div>

      <el-row :gutter="20">
        <el-col :span="6">
          <div class="container-body" :style="bodyHeight">
            <div class="address-book-list-search">
              <input placeholder="请输入你想要搜索的关键字" v-model="form.keyword" clearable @keyup.enter="handleQueryClick"></input>
              <button    @click="handleQueryClick">搜索</button>
            </div>
            <div class="address-book-list-tree" :style="treeHeight">
              <el-tree
                style="height: 100%"
                class="filter-tree"
                :data="treeData"
                node-key="value"
                :props="defaultProps"
                :check-on-click-node="true"
                :check-strictly="true"
                @check="treeCheck"
                @node-click="handleNodeClick"
                ref="tree">
              </el-tree>
            </div>
          </div>
        </el-col>

        <el-col :span="18">
          <div class="container-body container-body-right" :style="bodyHeight">
            <div class="address-book-list-crumb">
              <span style="line-height: 30px">{{ breadcrumb }}</span>
            </div>

            <div style="height: calc( 100% - 100px);margin-top: 20px;">
              <div v-if="memberData && memberData.length != 0" style="height: 100%;overflow-y: scroll;">
                <div class="address-book-list-member" :style="`background-color:${addressBookColors[index%2]}`" v-for="(item,index) of memberData" :key="index" style="cursor: pointer" @click="handleViewClick(item)">
                  <div class="member-follow">
                    <i v-if="item.isFollow == '1'" class="el-icon-star-on follow-click" @click.stop="handleFollowClick(item, '0')" ></i>
                    <i v-else class="el-icon-star-on cancle-follow" @click.stop="handleFollowClick(item, '1')"></i>
                  </div>
                  <div class="member-left" :style="`background-image: url(${avatarPre+item.avatar})`"></div>
                  <div class="member-right member-name">
                    <span :title="item.name">{{ item.name }}</span><br>
                  </div>

                  <div class="member-right member-dept">
                    <span v-if="item.tp=='6'" :title="item.pName+'_'+ item.deptName + (item.section ? ' | '+item.section : '')">
                      {{ item.pName+'_'+item.deptName }}
                      <span v-if="item.section" style="font-weight: 600;">|</span>
                      {{ item.section }}
                    </span>
                    <span v-else :title="item.deptName+(item.section ? ' | '+item.section : '')">
                      {{ item.deptName }}
                      <span v-if="item.section" style="font-weight: 600;">|</span>
                      {{ item.section }}
                    </span>
                  </div>

                  <div v-if="admin" class="member-right member-phone" style="line-height: 40px">
                    <span :title="item.phone">电话：{{ item.phone }}</span>
                    <i class="icon-fuzhi1 iconfont" @click.stop="copyPhoneClick(index,item)" style="cursor: pointer"></i>
                  </div>

                  <div v-if="admin" class="member-right member-mail" style="line-height: 40px">
                    <span :title="item.mail">邮箱：{{ item.mail }}</span>
                  </div>

                  <div class="member-right member-tag">
                    <div class="member-right-text" v-if="item.lv1Desc != '其他' && item.lv1Desc">
                      <span>{{ item.lv1Desc }}</span>
                    </div>
                    <div class="member-right-text" v-if="item.lv2Desc != '其他' && item.lv2Desc">
                      <span>{{ item.lv2Desc }}</span>
                    </div>
                    <div class="member-right-text" v-if="item.lv1Desc == '其他' || item.lv2Desc == '其他' && item.directionLv2Desc">
                      <span>{{ item.directionLv2Desc }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty-data" v-else>
                <img src="static/images/empty_data.png"/>
                <span>暂无数据</span>
              </div>
              <div class="pagination-container" :style="paginationHide">
                <el-pagination style="float: right; padding: 3px 0"
                               layout="sizes, prev, pager, next" :page-size="pageSize" :total="total" :page-sizes="pageSizeArray"
                               @current-change="handlePageChange"
                               @size-change="handleSizeChange"
                               :current-page="currentPage">
                </el-pagination>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <common-dialog
      width="600px"
      :visible.sync="dialog.isShow"
      v-loading="dialog.isLoading"
      class="spec-dialog"
      @close="handleCloseDialog"
    >
      <div class="dialog-title" slot="title">
        <template>
          <div>名片</div>
        </template>
      </div>
      <div class="dialog-body">
        <div
          class="dialog-body-img"
          :style="`background-image: url(${avatarPre + dialog.form.avatar})`"
        ></div>
        <div class="dialog-body-data-all">
          <div class="dialog-body-data" :title="dialog.form.name">
            <span class="dialog-body-data-text"
              >姓名：{{ dialog.form.name }}</span
            >
          </div>
          <div class="dialog-body-data">
            <span class="dialog-body-data-text" v-if="dialog.form.tp == '6'"
              >机构：{{ dialog.form.pName + "_" + dialog.form.deptName }}</span
            >
            <span class="dialog-body-data-text" v-else
              >机构：{{ dialog.form.deptName }}</span
            >
          </div>
          <div class="dialog-body-data">
            <span class="dialog-body-data-text"
              >科室：{{ dialog.form.section }}</span
            >
          </div>
          <div class="dialog-body-data">
            <span class="dialog-body-data-text"
              >电话：{{ dialog.form.phone }}</span
            >
          </div>
          <div class="dialog-body-data">
            <span class="dialog-body-data-text"
              >邮箱：{{ dialog.form.mail }}</span
            >
          </div>

          <div class="dialog-body-data">
            <span class="dialog-body-data-text"
              >一级研究方向：{{ dialog.form.lv1Desc }}</span
            >
          </div>
          <div class="dialog-body-data">
            <span class="dialog-body-data-text"
              >二级研究方向：{{ dialog.form.lv2Desc }}</span
            >
          </div>
          <div
            class="dialog-body-data"
            v-if="
              dialog.form.lv1Desc == '其他' ||
                (dialog.form.lv2Desc == '其他' && dialog.form.directionLv2Desc)
            "
          >
            <span class="dialog-body-data-text"
              >其它研究方向：{{ dialog.form.directionLv2Desc }}</span
            >
          </div>
        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <common-button type="cancel" @click="dialog.isShow = false"
          >取消</common-button
        >
      </div>
    </common-dialog>

    <!--动画加载组件-->
    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="'Loading'"
    ></animation>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import Animation from "../../components/loading/animation";
import { mapState } from "vuex";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";

export default {
  name: "AddressBookList",
  components: { Animation },
  data() {
    return {
      breadcrumb: "", //面包屑
      treeData: [], //树的数据
      expandedKeys: [], //默认展开的节点数组
      memberData: [], //成员数据
      pageNum: 1,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizeArray: PAGE_SIZE_ARRAY,
      form: {
        keyword: "" //关键字
      },
      query: {
        keyword: ""
      },

      dialog: {
        isShow: false,
        isLoading: false,
        form: []
      },
      paginationHide: {
        //分页的样式
        display: ""
      },
      addressBookColors: ["#f3fdff", "#fff"],
      bodyHeight: {
        height: ""
      },
      treeHeight: {
        height: ""
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      loadingDataVisible: false,
      avatarPre: "",
      deptValue: null,
      swich: false //点击关注功能请求开关
    };
  },

  watch: {
    memberDataFlag: {
      handler: function(newval, oldval) {
        if (newval) {
          this.getMemberData();
        }
      },
      deep: true
    }
  },

  mounted() {
    if (this.$route.query.keyword) {
      this.form.keyword = this.$route.query.keyword;
      this.query.keyword = this.$route.query.keyword;
    }

    this.getAllDepartAndMember();
    this.getAddressBookMember();
  },

  methods: {
    //根据点击左边的树节点返回右边的成员
    getMemberData() {
      let data = this.treeData;
      let id = this.deptValue;
      let result = null;
      for (let arr of data) {
        result = this.getChildAddressBooks(arr, id);
        if (result) {
          break;
        }
      }
      this.memberData = result;
    },

    //递归查询成员信息
    getChildAddressBooks(data, id) {
      if (!data.children) {
        if (data.value === id) {
          return data.addressBooks;
        } else {
          return null;
        }
      } else {
        if (data.value == id) {
          return data.addressBooks;
        } else {
          let childrenItem = data.children;
          let childrenResult = null;
          for (let item of childrenItem) {
            childrenResult = this.getChildAddressBooks(item, id);
            if (childrenResult) {
              return childrenResult;
            }
          }
        }
      }
    },

    //自适应高度
    getHeight() {
      this.treeHeight.height = window.innerHeight - 288 + "px";
      this.bodyHeight.height = window.innerHeight - 193 + "px";
    },

    handleGoBackClick() {
      this.$router.go(-1);
    },

    //获取树的数据
    getAllDepartAndMember() {
      let _this = this;
      _this.loadingDataVisible = true;
      let token = cookie.getCookie("token");
      let url = "";
      if (this.admin) {
        url = "/eims-api/addressBook/findAllDepartAndMemberIsPower";
      } else {
        url = "/eims-api/addressBook/findAllDepartAndMember";
      }
      http
        .post(window.config.api.baseUrl + url, {
          token: token,
          data: {}
        })
        .then(response => {
          if (response.data.code == "00000") {
            _this.treeData = response.data.data.trees;
          }
        })
        .finally(() => {
          _this.loadingDataVisible = false;
        });
    },

    //搜索按钮
    handleQueryClick() {
      this.deptValue = null;
      this.query.keyword = this.form.keyword;
      this.handlePageChange(1);
    },

    //获取全部通讯录成员
    getAddressBookMember() {
      this.deptValue = null;
      let _this = this;
      let token = cookie.getCookie("token");
      _this.loadingDataVisible = true;
      _this.paginationHide.display = "";
      let url = "";
      if (this.admin) {
        url = "/eims-api/addressBook/findAddrBookIsPower";
      } else {
        url = "/eims-api/addressBook/findAddrBook";
      }
      http
        .post(window.config.api.baseUrl + url, {
          token: token,
          data: {
            keyWord: _this.query.keyword,
            pageNum: _this.pageNum,
            pageSize: _this.pageSize
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            _this.memberData = response.data.data.addressBooks;
            let total = response.data.data.total;
            this.total = total;
            if (this.query.keyword) {
              _this.breadcrumb =
                "关键字：" +
                this.query.keyword +
                "\xa0\xa0\xa0\xa0总共找到" +
                total +
                "个成员";
            } else {
              _this.breadcrumb = "总共有" + total + "个成员";
            }
          }
        })
        .finally(() => {
          _this.loadingDataVisible = false;
        });
    },

    //分页
    handlePageChange(val) {
      this.currentPage = val;
      this.pageNum = val;
      if (this.deptValue) {
        this.getAddressBookMemberByTree(this.deptValue);
      } else {
        this.getAddressBookMember();
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      if (this.deptValue) {
        this.getAddressBookMemberByTree(this.deptValue);
      } else {
        this.getAddressBookMember();
      }
    },

    nodeExpand(data) {
      this.expandedKeys.push(data.value);
    },

    nodeCollapse(data) {
      this.expandedKeys.splice(this.expandedKeys.indexOf(data.value), 1);
    },

    treeCheck(node, list) {
      //todo 保留树单选作为条件
      if (list.checkedKeys.length == 2) {
        //单选实现
        this.$refs.tree.setCheckedKeys([node.value]);
      }
    },

    //获取全部通讯录成员
    getAddressBookMemberByTree(value) {
      let _this = this;
      let token = cookie.getCookie("token");
      _this.loadingDataVisible = true;
      _this.paginationHide.display = "";
      let url = "";
      if (this.admin) {
        url = "/eims-api/addressBook/findAddrBookIsPower";
      } else {
        url = "/eims-api/addressBook/findAddrBook";
      }
      http
        .post(window.config.api.baseUrl + url, {
          token: token,
          data: {
            id: value,
            pageNum: _this.pageNum,
            pageSize: _this.pageSize
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            _this.memberData = response.data.data.addressBooks;
            let total = response.data.data.total;
            this.total = total;
            let allDeptName = this.getAllDeptName(this.treeData, value);
            let result = allDeptName.replace(
              new RegExp(",", "g"),
              "\u00A0>\u00A0"
            );
            this.breadcrumb =
              result + "：\xa0\xa0\xa0共找到" + this.total + "个成员 ";
          }
        })
        .finally(() => {
          _this.loadingDataVisible = false;
        });
    },

    getAllDeptName(treeData, deptValue) {
      if (treeData == null || treeData.length == 0) {
        return "";
      }
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].value == deptValue) {
          return treeData[i].label;
        } else {
          let obj = this.getAllDeptName(treeData[i].children, deptValue);
          if (obj) {
            return treeData[i].label + " , " + obj;
          }
        }
      }
    },

    //获取节点数据以及节点
    handleNodeClick(data, node) {
      this.deptValue = data.value;
      this.paginationHide.display = "";
      if (data) {
        this.getAddressBookMemberByTree(this.deptValue);
      }
    },

    //点击关注按钮
    handleFollowClick(item, flag) {
      if (this.swich) return;
      this.swich = true;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/addressBook/followMember",
          {
            token: token,
            data: {
              followUserId: item.id,
              flag: flag
            }
          }
        )
        .then(response => {
          if (response.data.code == "00000") {
            if (flag == "1") {
              Message.success({ message: "关注成功！", showClose: true });
            } else if (flag == "0") {
              Message.success({ message: "已取消关注！", showClose: true });
            }
            if (!this.deptValue) {
              this.getAddressBookMember();
            } else {
              this.getAddressBookMemberByTree(this.deptValue);
            }
          }
        })
        .finally(() => {
          this.swich = false;
        });
    },

    //导出通讯录信息
    exportAddressBook() {
      let token = cookie.getCookie("token");
      window.open(
        window.config.api.baseUrl +
          "/eims-api/addressBook/exportExcel?token=" +
          token
      );
    },

    //复制手机号码方法
    copyPhoneClick(index, item) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = item.name + " " + item.phone;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      Message.success({ message: "复制成功！", showClose: true });
      // 复制后移除输入框
      oInput.remove();
    },

    //复制邮箱
    copyMailClick(index, item) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = item.name + " " + item.mail;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      Message.success({ message: "复制成功！", showClose: true });
      // 复制后移除输入框
      oInput.remove();
    },

    //点击打开弹窗
    handleViewClick(item) {
      this.loadingDataVisible = true;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/addressBook/getAddressBookInfo",
          {
            token: token,
            data: {
              id: item.id
            }
          }
        )
        .then(response => {
          this.dialog.isShow = true;
          if (response.data.code == "00000") {
            this.dialog.form = response.data.data.addressBook;
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
        });
    },

    //关闭弹窗
    handleCloseDialog() {
      this.dialog.isShow = false;
      this.dialog.form = {};
    }
  },

  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.avatarPre = window.config.avatar.baseUrl + "/";
  },

  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },

  computed: {
    //右边数据是否为点击机构时的数据
    memberDataFlag() {
      if (this.treeData && this.deptValue) {
        return true;
      } else {
        return false;
      }
    },
    admin() {
      return this.systemPower || this.superPower || this.deptPower;
    },
    ...mapState({
      superPower: state => state.userPowerStore.superPower,
      systemPower: state => state.userPowerStore.systemPower,
      deptPower: state => state.userPowerStore.deptPower
    })
  }
};
</script>

<style lang="scss" scoped>
.address-book-list {
  padding: 20px;
  .component-container {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 1px 2px 5px #ccc;
    .container-head {
      border-bottom: 1px solid #f5f5f5;
      padding: 10px;
      line-height: 20px;
      overflow: auto;
      display: flex;
      flex-direction: row;
      width: 100%;
      .container-head-title {
        width: 100%;
        i {
          vertical-align: top;
          line-height: 44px;
        }
        span {
          vertical-align: top;
          line-height: 44px;
        }
        div {
          vertical-align: top;
          height: 44px;
        }
        button {
          height: 44px;
        }
        .icon-tongxunlu {
          color: #42c6e2;
          font-size: 30px;
        }
      }
    }
  }
  .container-body {
    padding: 10px;
    box-shadow: rgb(174, 182, 174) 5px 0px 10px -5px;
    .address-book-list-search {
      input {
        padding-left: 10px;
        width: 85%;
        height: 50px;
        border: solid 1px #cccccc;
        font-size: 15px;
        outline-color: #cccccc;
        border-radius: 5px 0 0 5px;
      }
      button {
        width: 15%;
        height: 50px;
        border-style: none;
        border-color: unset;
        margin-left: -5px;
        background-color: #42c6e2;
        border-radius: 0 5px 5px 0;
        background-image: url("/static/images/fourbackground.png");
        color: white;
      }
    }
    .address-book-list-tree {
      margin-top: 20px;
    }
  }
  .container-body-right {
    background-color: #fff;
    height: 750px;
    .address-book-list-crumb {
      font-family: SourceHanSansSC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      height: 30px;
    }
    .address-book-list-member {
      display: flex;
      height: 60px;
      background-color: #fff;
      padding: 10px 20px;
      border-radius: 5px;
      .member-follow {
        width: 45px;
        .el-icon-star-on {
          font-size: 40px;
          cursor: pointer;
        }
        .follow-click {
          color: #eeee0b8f;
        }
        .cancle-follow {
          color: #96969645;
        }
      }
      .member-left {
        width: 40px;
        height: 40px;
        background-size: cover;
        border-radius: 10px;
        span {
          font-size: 40px;
          border-radius: 10px;
        }
      }
      .member-right {
        padding-left: 20px;
        position: relative;
        line-height: 40px;
        font-size: 15px;
        font-weight: 500;
        color: #000000;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .member-right-text {
          padding: 0 20px;
          height: 30px;
          background-color: #ccf0f9;
          text-align: center;
          line-height: 30px;
          border-radius: 20px;
          font-size: 14px;
          color: #34c5e7;
          display: inline-block;
          vertical-align: middle;
        }
        /*去掉复制前面的图标*/
        .icon-fuzhi1:before {
          content: "";
        }

        /*将图标放在后面*/
        .icon-fuzhi1:after {
          color: rgb(94, 213, 217);
          margin: 0 10px;
          content: "\ec7a";
        }
      }
      .member-name {
        width: calc(8% );
        line-height: 40px;
      }

      .member-dept {
        width: calc(25% );
        line-height: 40px;
      }
      .member-phone {
        width: calc(15% );
      }
      .member-mail {
        width: calc(20% );
      }
      .member-tag {
        width: calc(25% );
      }
    }
    .pagination-container {
      margin-top: 10px;
    }
    .empty-data {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex-direction: column;
      img {
        width: 40%;
      }
      span {
        font-size: 18px;
        color: #999999;
      }
    }
  }
  /*  名片页面dialog */
  .dialog-body {
    font-size: 16px;
    line-height: 30px;
    &-img {
      float: left;
      width: 200px;
      height: 200px;
      background-size: cover;
      margin-top: 20px;
    }

    &-data-all {
      margin-left: 230px;
      line-height: 40px;
      height: 240px;
    }

    &-data {
      width: 100%;
    }

    &-data-text {
      font-size: 16px;
      float: left;
      flex: 1;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

/* tree的图标 */
/deep/ .el-icon-caret-right:before {
  content: "\e6e0";
}

/* tree的字号 */
/deep/ .el-tree-node__content span {
  font-size: 18px;
}

/deep/ .el-tree-node__content {
  height: 45px;
  font-weight: 400;
}

/* tree的滚动条 */
/deep/.el-tree {
  width: 100%;
  overflow: scroll;
}

/deep/.el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/addressBook/AddressBookList.vue